import { render, staticRenderFns } from "./SidebarTypeAdmin.vue?vue&type=template&id=dc657156&scoped=true"
import script from "./SidebarTypeAdmin.vue?vue&type=script&lang=js"
export * from "./SidebarTypeAdmin.vue?vue&type=script&lang=js"
import style0 from "./SidebarTypeAdmin.vue?vue&type=style&index=0&id=dc657156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc657156",
  null
  
)

export default component.exports